import utils from '@/services/utils';

// eslint-disable-next-line
export const query = (operation, variables, loading, options = {}) => {
  return utils.post('/graphql', {
    query: operation,
    variables: utils.jsonify(variables),
  }, loading, options);
};

// eslint-disable-next-line
export const mutation = (operation, variables, loading, options = {}) => {
  return utils.post('/graphql', {
    query: operation,
    variables: utils.jsonify(variables),
  }, loading, options);
};
